
import { BasicOrderMealItem, MonoMenuEntree } from '@/models';
import { requiredEntreeContentsByType, TemporaryContentGroups } from './meal-builder-v2-constants';
import { MonoMenuService } from '../mono-menu/mono-menu.service';

// Meal Builder v2 Check to add items to an entree that COP expects, but that a customer does not select via the UI
export function addRequiredEntreeContents(monoMenu: MonoMenuService, entree: MonoMenuEntree, entreeContents: BasicOrderMealItem[]): void {
  const requiredContentIds = requiredEntreeContentsByType[entree.itemType];
  if (requiredContentIds !== null) {
    for (const contentId of requiredContentIds) {
      // Let's not re-add this if it's already in there (i.e. recents or favorites)
      if (!entreeContents.find(c => c.menuItemId == contentId)) {
        const item = monoMenu.getMonoMenuItem(contentId);
        entreeContents.push({
          isUpSell: false,
          menuItemId: contentId,
          menuItemName: item?.itemName || '',
          quantity: 1,
        });
      }
    }
  }
}

// if we are looking at tacos, its not an entree and single tacos is selected
export function adjustTacosMulitplier(monoMenu: MonoMenuService, itemId: string | undefined, topLevelMenuItemTitle: string | null, entreeId: string | null, currentMultiplier: number) {
  
  if (topLevelMenuItemTitle === 'Tacos' && !monoMenu.isEntreeId(itemId) && parseInt((entreeId || '').slice(4), 10) > 1000 ) {
    const item = monoMenu.getMonoMenuItem(itemId!);

    if (item?.rules.contentGroupName !== TemporaryContentGroups.SideContentGroup && item?.rules.contentGroupName !== TemporaryContentGroups.DrinkContentGroup) {
      return currentMultiplier /= 3;
    }
  }

  return currentMultiplier;
}
